import i, { forwardRef as f, useState as y, useRef as o, useMemo as h } from "react";
import { u as p, m as b } from "./index-615eb227.mjs";
const s = {
  width: "100%",
  height: "100%",
  aspectRatio: "1",
  objectFit: "contain"
}, E = f(function({ src: n, fallbackImgSrc: e }, u) {
  const [c, l] = y(!1), r = o(!1), t = o(null), d = h(
    () => e ? /* @__PURE__ */ i.createElement("img", { src: e, "aria-hidden": !0, style: s }) : null,
    [e]
  );
  return p(t, (m) => {
    const a = t.current;
    !a || !m || r.current || (r.current = !0, a?.play()?.catch(() => l(!0)));
  }), !n || c ? d : /* @__PURE__ */ i.createElement(
    "video",
    {
      ref: b(u, t),
      src: n,
      style: s,
      muted: !0,
      playsInline: !0,
      disablePictureInPicture: !0,
      disableRemotePlayback: !0,
      tabIndex: -1,
      preload: "true",
      "x-webkit-airplay": "deny",
      "aria-hidden": !0
    }
  );
});
export {
  E as V
};
//# sourceMappingURL=VideoIcon-c13b94d3.mjs.map
